import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import asyncComponent from './helpers/AsyncFunc';
import Privacy from './components/Privacy';
import ToS from './components/ToS';
// import Home from './containers/Home';
const Routes = () => {
  return (
    <Router>
      <div>
        <Route exact path="/" component={asyncComponent(() => import('./containers/HomePage'))} />
        <Route path="/activate/:activateCode" component={asyncComponent(() => import('./containers/ActivatePage'))} />
        <Route
          path="/reset-password/:forgotten_password_code"
          component={asyncComponent(() => import('./containers/ResetPassword'))}
        />
        <Route path="/wifi/:nasId" component={asyncComponent(() => import('./containers/Wifi'))} />
        <Route path="/form/:pageId" component={asyncComponent(() => import('./containers/WifiRegisterForm'))} />
        <Route path="/wifi-upgrade/:taskCodeId" component={asyncComponent(() => import('./containers/WifiUpgrade'))} />
        <Switch>
          <Route exact path="/home" component={asyncComponent(() => import('./containers/HomePage'))} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/tos" component={ToS} />
          <Route exact path="/facebook/deletionStatus" component={asyncComponent(() => import('./containers/Facebook/DataDeletion'))} />
          <Route exact path="/splash" component={asyncComponent(() => import('./containers/Splash'))} />
          <Route exact path="/fbcallback" component={asyncComponent(() => import('./containers/OAuth/fbcallback'))} />
          <Route
            exact
            path="/:idOrUsername"
            component={asyncComponent(() => import('./containers/TaskHome'))}
          />
        </Switch>
      </div>
    </Router>
  );
}

export default Routes;
